export const VIEW_REWARD_TYPE = "VIEW_REWARD_TYPE"
export const VIEW_REWARD_TYPE_SUCCESS = "VIEW_REWARD_TYPE_SUCCESS"
export const VIEW_REWARD_TYPE_FAILED = "VIEW_REWARD_TYPE_FAILED"